module.exports = __webpack_public_path__ + "static/media/i_menu_tutorial.b8666be0.png";